export const money = (value: number) => `¥ ${Number(value).toLocaleString('zh-CN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}`

export const compactMoney = (value: number) => `¥ ${Number(value).toLocaleString('zh-CN', {
  maximumFractionDigits: 0
})}`

export const dateOnly = (value: unknown) => String(value ?? '').slice(0, 10)

export const dateTimeText = (value: unknown) => value
  ? new Date(String(value)).toLocaleString('zh-CN', { hour12: false }).replaceAll('/', '-')
  : ''

export const today = () => {
  const value = new Date()
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
}

export const monthStart = (value: string) => `${value.slice(0, 8)}01`
export const salesPeriodLabel = (period: string) => period === 'morning' ? '上午' : '下午'

export const quantityText = (value: number, unit: string) =>
  `${Number(value).toLocaleString('zh-CN', { maximumFractionDigits: 2 })}${unit}`

export const isValidQuantity = (value: number, scale: number) => {
  if (!Number.isFinite(value) || value <= 0) return false
  const factor = 10 ** scale
  const scaled = value * factor
  return Math.abs(Math.round(scaled) - scaled) < 1e-8
}
